<template>
  <div class="program inner">
    <figure class="program-thumbnail">
      <div class="thumbnail">
        <img
          :src="program.imageUrl"
          :alt="program.title"
        >
      </div>
      <figcaption
        v-if="program.deliveryFrame && program.deliveryFrame.length > 1"
      >
        <div
          class="time"
          :class="{
            'program-onair': status === 'doing',
            'program-end': status === 'done'
          }"
        >
          <template v-if="status === 'doing'">
            LIVE配信中
          </template>
          <template v-else-if="status === 'will'">
            {{ startAtFormatted }}配信
          </template>
          <template v-else>
            終了
          </template>
        </div>
      </figcaption>
    </figure>
    <div class="program-detail">
      <div class="keyword" v-if="liveType === 'company'">
        <PresentIcon />
        <p>抽選会キーワード付き企業LIVE</p>
      </div>
      <section>
        <Title>
          <template #title>
            配信スケジュール
          </template>
        </Title>
        <div class="content">
          <h4 v-if="schedules0624.length > 0 && schedules0625.length > 0">6月24日(水)</h4>
          <div class="schedules">
            <ScheduleList
              v-for="frame in schedules0624"
              :key="frame"
              :frame="frame"
              date="2020-06-24"
              :deliveryTime="program.deliveryTime"
            />
          </div>
          <h4 v-if="schedules0624.length > 0 && schedules0625.length > 0">6月25日(木)</h4>
          <div class="schedules">
            <ScheduleList
              v-for="frame in schedules0625"
              :key="frame"
              :frame="frame"
              date="2020-06-25"
              :deliveryTime="program.deliveryTime"
            />
          </div>
        </div>
      </section>
      <section>
        <Title>
          <template #title>
            配信時間
          </template>
        </Title>
        <div class="content">
          {{ len }}分
        </div>
      </section>
      <section v-if="liveType === 'company' && program.present">
        <Title>
          <template #title>
            参加者特典
          </template>
        </Title>
        <div class="content">
          <p v-html="livePresent" />
        </div>
      </section>
      <section>
        <Title>
          <template #title>
            配信内容
          </template>
        </Title>
        <div class="content">
          <p v-html="liveDetail" />
        </div>
      </section>
      <section>
        <div v-if="program.tool !== '1'" class="note">
          <p>
            {{ program.tool | setDescription(liveType, description) }}
          </p>
        </div>
      </section>
      <section>
        <Title>
          <template #title>
            出展者情報
          </template>
        </Title>
        <div class="content">
          <p v-if="liveType === 'company'">
            {{ program.exhibitorName }}
          </p>
          <p v-if="liveType === 'provider'">
            {{ program.eventname }}
          </p>
          <p v-if="liveType === 'company'">
            <a :href="program.exhibitorUrl">
              {{ program.exhibitorUrl }}
            </a>
          </p>
          <p v-if="liveType === 'provider' && program.exhibitor_url1">
            <a :href="program.exhibitor_url1">
              {{ program.exhibitor_url1 }}
            </a>
          </p>
          <p v-if="liveType === 'provider' && program.exhibitor_url2">
            <a :href="program.exhibitor_url2">
              {{ program.exhibitor_url2 }}
            </a>
          </p>
          <p v-if="liveType === 'provider' && program.exhibitor_url3">
            <a :href="program.exhibitor_url3">
              {{ program.exhibitor_url3 }}
            </a>
          </p>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import Title from '@/components/atoms/Title.vue'
import PresentIcon from '@/components/atoms/PresentIcon.vue'
import ScheduleList from '@/components/molecules/ScheduleList.vue'

export default {
  props: {
    program: {
      type: Object,
      required: true
    },
    liveType: {
      type: String,
      required: true
    }
  },
  components: {
    Title,
    PresentIcon,
    ScheduleList
  },
  computed: {
    schedules0624 () {
      if (this.program.deliveryFrame) {
        return this.program.deliveryFrame.filter((frame) => {
          return Number(frame) <= 10
        })
      } else {
        return false
      }
    },
    schedules0625 () {
      if (this.program.deliveryFrame) {
        return this.program.deliveryFrame.filter((frame) => {
          return Number(frame) >= 11
        })
      } else {
        return false
      }
    },
    liveDate () {
      if (this.schedules0624 && this.schedules0625) {
        return '6月24日(水)、6月25日(木)'
      } else if (this.schedules0624) {
        return '6月24日(水)'
      } else {
        return '6月25日(木)'
      }
    },
    livePresent () {
      const text = this.program.present
      const reg = new RegExp("((https?|ftp)(://[-_.!~*'()a-zA-Z0-9;/?:@&=+$,%#]+))", 'g')
      return text.replace(reg, "<a href='$1' target='_blank'>$1</a>")
    },
    liveDetail () {
      const text = this.program.detail
      const reg = new RegExp("((https?|ftp)(://[-_.!~*'()a-zA-Z0-9;/?:@&=+$,%#]+))", 'g')
      return text.replace(reg, "<a href='$1' target='_blank'>$1</a>") || text
    },
    now () {
      return this.$moment()
    },
    len () {
      let time = ''
      switch (this.program.deliveryTime) {
        case '1':
          time = 10
          break
        case '2':
          time = 15
          break
        case '3':
          time = 20
          break
        case '4':
          time = 25
          break
        case '5':
          time = 30
          break
        case '6':
          time = 40
          break
        case '7':
          time = 60
          break
      }
      return time
    },
    invertTable () {
      return _.invert(this.table)
    },
    keysTable () {
      return _.keys(this.invertTable)
    },
    dayFrame () {
      return _.intersection(this.program.deliveryFrame, this.keysTable)
    },
    firstFrame () {
      return this.invertTable[this.dayFrame[0]]
    },
    lastFrame () {
      return this.invertTable[this.dayFrame[this.dayFrame.length - 1]]
    },
    startAtFormatted () {
      return this.$moment(this.startAt).format('H:mm')
    }
  },
  data: () => ({
    description: {
      // instagram: '時間になるとライブが開始されます。\nアカウントをおもちでしたらPCからでも視聴可能です。',
      youtube: '時間になると視聴可能になります。\nブラウザの場合、時間になりましたら再読み込みをしてください。\nコメントにはアカウントログインが必要です。',
      zoomMeeting: '時間になると視聴可能になります。\n事前にZoomアプリのインストールをお願いします。\n講師や参加者とコミュニケーションを取るため、できる限りマイク・カメラはオンにしてご参加いただけますと幸いです。\n※マイクとカメラがオンで開始される場合もありますので、ご注意ください。',
      zoomWebinar: '時間になると視聴可能になります。\n事前にZoomアプリのインストールをお願いします。\n参加者のカメラ・マイク機能はオフになります。'
    },
    table: {
      '2020-06-24 10:30': 1,
      '2020-06-24 11:00': 2,
      '2020-06-24 11:30': 3,
      '2020-06-24 12:00': 4,
      '2020-06-24 12:30': 5,
      '2020-06-24 13:00': 6,
      '2020-06-24 13:30': 7,
      '2020-06-24 14:00': 8,
      '2020-06-24 14:30': 9,
      '2020-06-24 15:00': 10,
      '2020-06-25 10:30': 11,
      '2020-06-25 11:00': 12,
      '2020-06-25 11:30': 13,
      '2020-06-25 12:00': 14,
      '2020-06-25 12:30': 15,
      '2020-06-25 13:00': 16,
      '2020-06-25 13:30': 17,
      '2020-06-25 14:00': 18,
      '2020-06-25 14:30': 19,
      '2020-06-25 15:00': 20
    },
    status: 'will',
    startAt: '',
    endAt: ''
  }),
  filters: {
    setDescription (tool, liveType, description) {
      if (liveType === 'provider') {
        if (tool === '2') {
          return description.youtube
        } else if (tool === '3') {
          return description.zoomMeeting
        } else if (tool === '4') {
          return description.zoomWebinar
        }
      } else if (liveType === 'company') {
        if (tool === '2') {
          return description.zoomWebinar
        } else if (tool === '3') {
          return description.youtube
        }
      }
      return ''
    }
  },
  mounted () {
    this.setStatus()
  },
  watch: {
    'program.deliveryFrame': {
      handler (val, old) {
        this.setStatus()
      }
    }
  },
  methods: {
    setStatus () {
      if (this.now.isBefore('2020-06-24', 'day')) {
        this.startAt = this.firstFrame
      } else if (this.now.isAfter('2020-06-25', 'day')) {
        this.status = 'done'
        this.startAt = this.lastFrame
      } else {
        this.nextAndNow()
      }
    },
    nextAndNow () {
      let isBetween = false
      const isBefore = []
      this.dayFrame.forEach((frame) => {
        const start = this.invertTable[frame]
        const end = this.$moment(start).add(this.len, 'minutes')
        if (this.now.isBetween(start, end, 'minute', '[]')) {
          this.startAt = start
          this.endAt = end
          this.status = 'doing'
          isBetween = true
        } else if (this.now.isBefore(start)) {
          isBefore.push(start)
        }
      })
      if (!isBetween) {
        if (isBefore.length > 0) {
          this.status = 'will'
          this.startAt = isBefore[0]
          this.endAt = this.$moment(isBefore[0]).add(this.len, 'minutes')
        } else {
          this.status = 'done'
        }
      }
    }
  }
}
</script>
<style lang="sass" scoped>
.program-thumbnail
  padding-top: 25px
  border-radius: 8px
  overflow: hidden
  position: relative
  .thumbnail
    display: flex
    justify-content: center
    align-items: center
    @media only screen and (max-width: 600px)
      height: calc((100vw - 40px)/2)
    @media only screen and (min-width: 601px)
      height: 280px
    img
      max-width: 100%
  figcaption
    position: absolute
    left: 5px
    bottom: 5px
    .time
      color: #fff
      background-color: $green
      padding: 4px 10px
      border-radius: 20px
      font-size: 1.2rem
      &.program-onair
        background-color: $poppink
      &.program-end
        background-color: $gray
.program-detail section .content p
  white-space: pre-wrap
.program-detail
  margin-top: 10px
  .keyword
    display: flex
    align-items: center
    color: $green
    p
      margin-left: 10px
      font-weight: bold
  section
    margin-top: 20px
    .content
      margin-top: 15px
      h4:nth-child(n+2)
        margin-top: 10px
      p
        line-height: 1.6
        a
          color: $green
          text-decoration: underline
    .schedules
      display: flex
      flex-wrap: wrap
      margin-top: 5px
      div
        margin-right: 25px
        line-height: 2
.note
  background-color: #E4E4E4
  color: #858585
  font-size: 12px
  padding: 15px
  border-radius: 8px
  width: 100%
  line-height: 20px
</style>
